import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getDocuments({ commit }, {
        paginate = '',
        query = ''} = {}) {

        commit('GET_DOCUMENTS_REQUEST')

        return axios
            .get(`/docs-orders/doc-orders${paginate}${query}`)
            .then(response => {
                commit('GET_DOCUMENTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_DOCUMENTS_FAILURE')
                handleApiError(error, 'Pobranie listy zamówień dokumentów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getProductionDepartmentsForDocuments({ commit }) {
        commit('GET_PRODUCTION_DEPARTMENTS_REQUEST')

        return axios
            .get('/docs-orders/dicts/doc-order-production-departments')
            .then(response => {
                commit('GET_PRODUCTION_DEPARTMENTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_PRODUCTION_DEPARTMENTS_FAILURE')
                handleApiError(error, 'Pobranie działów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getTypes({commit}) {
        commit('GET_TYPES_REQUEST')

        return axios
            .get('/docs-orders/dicts/doc-order-types')
            .then(response => {
                commit('GET_TYPES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_TYPES_FAILURE')
                handleApiError(error, 'Pobranie rodzajów dokumentów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getStatuses({ commit }) {
        commit('GET_STATUSES_REQUEST')

        return axios
            .get('/docs-orders/dicts/doc-order-statuses')
            .then(response => {
                commit('GET_STATUSES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_STATUSES_FAILURE')
                handleApiError(error, 'Pobranie statusów zamówień dokumentów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createDocument({ commit }, payload) {
        return axios
            .post('/docs-orders/doc-orders', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie dokumentu zostało dodane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zgłoszenie zamówienia dokumentu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDocument(context, documentId) {
        return axios
            .get(`/docs-orders/doc-orders/${documentId}`)
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Pobranie zamówienia dokumentu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getDocumentComments(context, docOrderId) {
        return axios
            .get(`/docs-orders/doc-order-comments/${docOrderId}`)
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Pobranie komentarzy do zamówienia dokumentu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateDocument({ commit }, payload) {
        const { id, ...data } = payload

        return axios
            .put(`/docs-orders/doc-orders/${id}`, data)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zamówienie dokumentu zostało zaktualizowane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Aktualizacja zamówienia dokumentu nie powiodła się.')

                return Promise.reject(error)
            })
    },
    createDocumentComment(context, payload) {
        const { docOrderId, content } = payload || {}

        return axios
            .post(`/docs-orders/doc-order-comments/${docOrderId}`, {
                content,
                docOrderId
            })
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Dodanie komentarza do zamówienia dokumentu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createAttachment({ commit, state }, { formData, fileName, docOrderId }) {
        if (formData !== null) {
            const cancelToken = axios.CancelToken
            const cancelTokenSource = cancelToken.source()

            commit('SET_CANCEL_TOKEN', {
                token: cancelTokenSource,
                fileName: fileName
            })
        } else {
            commit('ABORT_FILE_UPLOAD', fileName)
        }

        const tokenIndex = state.uploadCancelTokens.findIndex(item => item.fileName === fileName)

        commit('FILE_PROGRESS', {
            show: true,
            value: 0,
            fileName: fileName
        }, { root: true })

        if (formData && docOrderId) {
            formData.append('docOrderId', docOrderId)
        }

        return axios
            .post('/docs-orders/doc-order-files', formData, {
                cancelToken: state.uploadCancelTokens[tokenIndex].token.token,
                timeout: 900000, // 15 min
                onUploadProgress(progressEvent) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)

                    commit('FILE_PROGRESS', {
                        show: true,
                        value: percentCompleted,
                        fileName: fileName
                    }, { root: true })
                }
            })
            .then(response => {
                if (response && response.data) {
                    response.data = {
                        ...response.data,
                        name: response.data.name || fileName
                    }
                }

                return Promise.resolve(response)
            })
            .catch(error => {
                if (error.message !== 'canceled') {
                    handleApiError(error, 'Dodanie załącznika nie powiodło się.')
                }

                return Promise.reject(error)
            })
            .finally(() => {
                commit('REMOVE_CANCEL_TOKEN', tokenIndex)
                commit('FILE_PROGRESS', {
                    show: false,
                    value: 0,
                    fileName: null
                }, { root: true })
            })
    },

    deleteAttachment({ state }, { file }) {
        return Promise.resolve().then(() => {
            const attachments = state.document.attachments || []

            state.document.attachments = attachments.filter(a => a.name !== file.name)

            return { data: { success: true } }
        })
    },

    getEligibleUsersForSharing() {
        const params = 'anyPermission=docs_order_update,docs_order_admin_update'

        return axios
            .get(`/users/users-simple?${params}`)
            .then(response => Promise.resolve(response))
            .catch(error => {
                handleApiError(error, 'Pobranie listy użytkowników nie powiodło się.')

                return Promise.reject(error)
            })
    }
}
